/** Astral Moon Magic legal URLs (main site). */
export const AMM_TERMS_URL = 'https://www.astralmoonmagic.com/terms-of-service';
export const AMM_PRIVACY_URL = 'https://www.astralmoonmagic.com/privacy-policy';
export const AMM_COOKIE_POLICY_URL = 'https://www.astralmoonmagic.com/cookie-policy';

/** localStorage: set when user accepts cookies in Numerology shell */
export const NUMEROLOGY_COOKIE_CONSENT_KEY = 'amm_numerology_cookie_consent_v1';

export function hasNumerologyCookieConsent() {
  if (typeof window === 'undefined') return true;
  try {
    return window.localStorage.getItem(NUMEROLOGY_COOKIE_CONSENT_KEY) === '1';
  } catch {
    return true;
  }
}

export function setNumerologyCookieConsent() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(NUMEROLOGY_COOKIE_CONSENT_KEY, '1');
  } catch {
    /* ignore */
  }
}
